<template>
  <b-card>
    <div class="row match-height ">
      <div class="col-sm-6 col-md-4 col-xl-2 ">
        <div class="card text-center bg-info bg-light-5">
          <div class="card-header ">
            <span class="mt-0 font-weight-bolder"> Bugün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.today"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.today.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.today.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-info bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Dün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.yesterday"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.yesterday.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.yesterday.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Son 7 Gün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.seven_day"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.seven_day.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.seven_day.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Geçen Son 7 Gün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.last_seven_day"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.last_seven_day.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.last_seven_day.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-success bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Bu Ay </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.month"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.month.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.month.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-success bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Geçen Ay </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.last_month"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.last_month.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.last_month.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-gradient-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Bu Yıl </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.year"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.year.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.year.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-gradient-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Geçen Yıl </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.last_year"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.last_year.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.last_year.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-gradient-success bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Son 1 Yıl </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.one_year"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.one_year.tr.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.one_year.tr.sum) }}
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-gradient-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Bu Yıl </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.year"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.year.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.year.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-gradient-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Geçen Yıl </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.last_year"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.last_year.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.last_year.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-gradient-success bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Son 1 Yıl </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.one_year"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.one_year.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.one_year.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-md-4 col-xl-2 ">
        <div class="card text-center bg-info bg-light-5">
          <div class="card-header ">
            <span class="mt-0 font-weight-bolder"> Bugün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.today"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.today.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.today.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-info bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Dün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.yesterday"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.yesterday.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.yesterday.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Son 7 Gün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.seven_day"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.seven_day.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.seven_day.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-warning bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Geçen Son 7 Gün </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.last_seven_day"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.last_seven_day.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.last_seven_day.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-success bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Bu Ay </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.month"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.month.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.month.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-xl-2">
        <div class="card text-center bg-success bg-light-5">
          <div class="card-header">
            <span class="mt-0 font-weight-bolder"> Geçen Ay </span>
          </div>
          <div
            v-if="_orderDetail && _orderDetail.last_month"
            class="card-body"
          >
            <div class="truncate">
              <h2 class="mb-25 font-weight-bolder">
                {{ _orderDetail.last_month.diger.count }} Adet
              </h2>
              <h3 v-if="user && user.role=='admin'">
                {{ priceFormart(_orderDetail.last_month.diger.sum, 'en-EN', 'EUR') }}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeStats',
  data: () => ({
    user: JSON.parse(localStorage.getItem('userData')),
  }),
  computed: {
    ...mapGetters('home', ['_orderDetail']),
  },
  created() {
    this.$store.dispatch('home/getOrderDetail')
  },
  methods: {
    priceFormart(price, format = 'tr-Tr', format2 = 'TRY') {
      const formattedOutput = new Intl.NumberFormat(format, {
        style: 'currency',
        currency: format2,
        minimumFractionDigits: 2,
      })
      return formattedOutput.format(price)
    },
  },
}
</script>
